import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { getDimensionOptions } from './getDimensionOptions'
import { Dimension } from '../types/Dimension'

interface UseCtxDimensionNameProps {
  dimensionId: Dimension['dimensionId'] | null
}

export const useCtxDimensionName = ({ dimensionId }: UseCtxDimensionNameProps) => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const options = getDimensionOptions(companyId)

  return useQuery({
    ...options,
    select: data => {
      const dimension = data?.find(item => item.dimensionId === dimensionId)
      return dimension?.name
    }
  })
}
